<template>
  <div>
    <button class="btn btn-success btn-xs" type="button" data-toggle="modal" data-target="#vesselOwnerHistoryModal"
            v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline">
      <i
          class="fa fa-ship"></i> Add Owner History Record
    </button>
    <table class="table table-hover table-bordered table-template-1 my-2 text-small">
      <thead>
      <tr>
        <th>#</th>
        <th>DATE TRANSFERRED</th>
        <th>OWNER FROM</th>
        <th>OWNER TO</th>
        <th class="col-actions" style="width: 10%;">ACTION</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="isLoading">
        <tr>
          <td colspan="100%">
            <app-loading></app-loading>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr v-for="(history,index) in vesselOwnerHistories" :key="history.id">
          <td>{{ index + 1 }}</td>
          <td class="text-center">{{ history.date_transferred | moment('DD MMM YYYY') }}</td>
          <td class="text-center">{{ history.owner_from }}</td>
          <td class="text-center">{{ history.owner_to }}</td>
          <td class="text-center">
            <template  v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline">
              <button class="btn btn-xs btn-warning mr-2" @click="alterParams(history)" data-toggle="modal" data-target="#vesselOwnerHistoryModal">
                <i class="fas fa-pen"></i> Edit
              </button>
              <button class="btn btn-xs btn-danger"
                      @click="deleteHistory(history.id)"><i class="fas fa-trash"></i></button>
            </template>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <div class="modal fade" id="vesselOwnerHistoryModal" tabindex="-1" aria-labelledby="vesselOwnerHistoryModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="vesselOwnerHistoryModalLabel">
              {{ params.hasOwnProperty('id') ? 'UPDATE ' : 'ADD ' }} HISTORY</h5>
            <button type="button" class="close" @click="resetFields" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row align-content-center">
               <label class="col col-sm-4 col-form-label font-weight-bolder">DATE TRANSFERRED :</label>
              <div class="col-8">
                <input type="date" v-model="params.date_transferred" class="form-control form-control-sm"
                       name="date-transferred" id="date-transferred">
              </div>
            </div>
            <div class="form-group row align-content-center">
              <label class="col col-sm-4 col-form-label font-weight-bolder">OWNER FROM :</label>
              <div class="col-8">
                <input type="text" v-model="params.owner_from" class="form-control form-control-sm"
                       name="date-transferred" placeholder="Owner From" id="date-transferred">
              </div>
            </div>
            <div class="form-group row align-content-center">
              <label class="col col-sm-4 col-form-label font-weight-bolder">OWNER TO :</label>
              <div class="col-8">
                <input type="text" v-model="params.owner_to" class="form-control form-control-sm"
                       name="date-transferred" placeholder="Owner To" id="date-transferred">
              </div>
            </div>
          </div>
          <div class="modal-footer">
<!--            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetFields">Close</button>-->
            <button type="button" class="btn btn-warning btn-xs" v-if="isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal" @click.prevent="consolidateModal">
              <i class="fas fa-pen"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading";
import {AlertServices} from "@/services/AlertServices";
import {gateMixin} from "@/mixins/gateMixin";

export default {
  name: "VesselOwnerHistory",
  components: {AppLoading},
  mixins:[gateMixin],
  data() {
    return {
      isLoading: false,
      params: {
        date_transferred: null,
        owner_from: '',
        owner_to: '',
        vessel_id: this.$route.params.id
      }
    }
  },
  computed: {
    ...mapGetters(['vesselOwnerHistories'])
  },
  methods: {
    ...mapActions(['getVesselOwnerHistories', 'addVesselOwnerHistory', 'updateVesselOwnerHistory','deleteVesselOwnerHistory']),

    async consolidateModal() {
      let response = false;
      if (this.params.hasOwnProperty('id')) {
        response = await this.updateHistory();
      } else {
        response = await this.addHistory();
      }

      if (response) {
        this.resetFields();
        $('#vesselOwnerHistoryModal').modal('hide');
        await this.getVesselOwnerHistories({id: this.$route.params.id})
      }
    },


    resetFields() {
      this.params = {
        date_transferred: null,
        owner_from: '',
        owner_to: '',
        vessel_id: this.$route.params.id
      }
    },

    async addHistory() {
      if (await AlertServices.confirmCreateAlert('Do you want to add this history ?')) {
        const response = await this.addVesselOwnerHistory(this.params)
        if (response) {
          AlertServices.successAlert('History added successfully', 'Add History')
          return true;
        }
        return false;
      }
    },

    async alterParams(params) {
      this.params = Object.assign({}, params)
    },

    async updateHistory() {
      if (await AlertServices.confirmUpdateAlert('Do you want to update this history ?')) {
        const response = await this.updateVesselOwnerHistory(this.params)
        if (response) {
          AlertServices.successAlert('History updated successfully', 'Update History')
          return true;
        }
        return false;
      }
    },

    async deleteHistory(id){
      if (await AlertServices.confirmDeleteAlert('Do you want to delete this history ?')) {
        const response = await this.deleteVesselOwnerHistory({id:id})
        if (response) {
          AlertServices.successAlert('History deleted successfully', 'Delete History')
          await this.getVesselOwnerHistories({id: this.$route.params.id})
          return true;
        }
        return false;
      }
    },

    async initializeData() {
      const params = {id: this.$route.params.id}
      this.isLoading = true
      await this.getVesselOwnerHistories(params)
      this.isLoading = false
    }

  },
  created() {
    this.initializeData()
  }
}
</script>

<style scoped>

</style>